module.exports = __webpack_public_path__ + "img/skjqrkzxtdszn.18d9fdfc.png";